import { render, staticRenderFns } from "./NewLicense.vue?vue&type=template&id=39b8c092&scoped=true&"
import script from "./NewLicense.vue?vue&type=script&lang=ts&"
export * from "./NewLicense.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b8c092",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFileInput,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39b8c092')) {
      api.createRecord('39b8c092', component.options)
    } else {
      api.reload('39b8c092', component.options)
    }
    module.hot.accept("./NewLicense.vue?vue&type=template&id=39b8c092&scoped=true&", function () {
      api.rerender('39b8c092', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/wizard/NewLicense.vue"
export default component.exports